import { BaseService } from "./BaseService";
import {
  CommunicationChannelKind,
  MessagingChannelConfig,
  UpsertMessagingChannelConfigRequest,
} from "@/types/messaging-channel-config";

class MessagingChannelConfigsService extends BaseService {
  private basePath(hotelId: string): string {
    return `/hotels/${hotelId}/messaging-channel-configs`;
  }

  list(hotelId: string): Promise<MessagingChannelConfig[]> {
    return this.get<MessagingChannelConfig[]>(this.basePath(hotelId));
  }

  upsert(
    hotelId: string,
    channel: CommunicationChannelKind,
    payload: UpsertMessagingChannelConfigRequest,
  ): Promise<MessagingChannelConfig> {
    return this.put<MessagingChannelConfig>(
      `${this.basePath(hotelId)}/${channel}`,
      payload,
    );
  }

  enable(
    hotelId: string,
    channel: CommunicationChannelKind,
  ): Promise<MessagingChannelConfig> {
    return this.post<MessagingChannelConfig>(
      `${this.basePath(hotelId)}/${channel}/enable`,
    );
  }

  disable(
    hotelId: string,
    channel: CommunicationChannelKind,
  ): Promise<MessagingChannelConfig> {
    return this.post<MessagingChannelConfig>(
      `${this.basePath(hotelId)}/${channel}/disable`,
    );
  }

  setDefault(
    hotelId: string,
    channel: CommunicationChannelKind,
  ): Promise<MessagingChannelConfig> {
    return this.post<MessagingChannelConfig>(
      `${this.basePath(hotelId)}/${channel}/set-default`,
    );
  }
}

export const messagingChannelConfigsService =
  new MessagingChannelConfigsService();
